import React, { Component } from 'react'
import './education.css';
export default class Education extends Component {
    render() {
        return (
            <section className="education">
            <h2 className="section-title">Education</h2>
            <div className="education-item">
              <h3>Vellore Institute of Technology</h3>
              <p>B.tech - CSE-Core</p>
              <p>2020 - 2024</p>
            </div>
            <div className="education-item">
              <h3>Royal Science School -Dhoraji</h3>
              <p>11th - 12th std.</p>
              <p>2018 - 2020</p>
            </div>
            <div className="education-item">
              <h3>shree v d patel saixanik sankul mandavad</h3>
              <p>7th to 10th std</p>
              <p>2015 - 2018</p>
            </div>
            <div className="education-item">
              <h3>Gurukrupa Primary School -Kalsari</h3>
              <p>K.G to 6th</p>
              <p>2007 - 2015</p>
            </div>
          </section>
        )
    }
}
